<template>
  <component
    :is="componentType"
    :aria-label="content.title"
    :href="content.url"
    class="content-card-old__content"
  >
    <!-- Content card image -->
    <slot />

    <div
      v-if="content.title || content.subtitle || content.button"
      class="content-card-old__copy"
    >
      <h2
        v-if="content.title"
        class="content-card-old__title text-body-l-medium"
        v-text="content.title"
      />

      <p
        v-if="content.subtitle"
        class="content-card-old__subtitle text-body-s-regular"
        v-text="content.subtitle"
      />

      <div>
        <btn
          v-if="content.button && content.url"
          :label="content.button"
          class="content-card-old__button"
          modifiers="text"
        />
      </div>
    </div>
  </component>
</template>

<script>

/**
 * Vue: Content card text
 * -----------------------------------------------------------------------------
 * Content card text used for the main collection's content cards
 * @deprecated
 * @param {Object} content - Text settings from content card block
 *
 */

import Btn from '~global/btn/btn'

export default {
  name: 'ContentCardTextOld',

  components: { Btn },

  props: {
    content: {
      type: Object,
      default: () => ({
        button: '',
        subtitle: '',
        title: '',
        url: '',
      }),
    },
  },

  computed: {
    componentType() {
      return this.content.url ? 'a' : 'div'
    },
  },
}
</script>
